import { Divider, Form } from "antd";
import { Dispatch, SetStateAction } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  updateStep1,
  updateStep25,
} from "../../../services/store/slices/onboarding";
import NameAndEmail from "../NameAndEmail";
import TeamSize from "../TeamSize";

type Props = {
  nextStep: any;
  data: any;
  updateData: Dispatch<SetStateAction<{ name: string; email: string }>>;
};

const Step1 = ({ nextStep }: Props) => {
  const dispatch = useDispatch();

  const { name, team_size_id, website_url } = useSelector(
    (state: any) => state?.SalonProfile?.step1
  );

  const TeamData = [
    { circles: ["#00086D"] },
    {
      circles: ["#CBCFFF", "#00086D", "#8389ED"],
    },
    {
      circles: [
        "#595FBC",
        "#CFCFE2",
        "#CBCFFF",
        "#CBCFFF",
        "#B0B0C0",
        "#CBCFFF",
        "#CFCFE2",
        "#595FBC",
      ],
    },
    {
      circles: [
        "#595FBC",
        "#CFCFE2",
        "#CBCFFF",
        "#B0B0C0",
        "#CBCFFF",
        "#CBCFFF",
        "#595FBC",
        "#CFCFE2",
        "#00086D",
        "#CFCFE2",
        "#595FBC",
        "#595FBC",
        "#CBCFFF",
        "#CBCFFF",
        "#CBCFFF",
      ],
    },
  ];

  const onFinish = (values: any) => {
    dispatch(updateStep1(values));
    dispatch(updateStep25(""));
    nextStep();
  };

  // useEffect(() => {
  //   dispatch(updateStep1([]));
  //   dispatch(updateStep2([]));
  //   dispatch(updateStep3([]));
  //   dispatch(updateStep4([]));
  // }, []);

  return (
    <Form
      name="step1"
      onFinish={onFinish}
      layout={"vertical"}
      className="flex flex-col items-center justify-center w-full"
      initialValues={{
        name: {
          ar: name?.ar || "",
        },
        team_size_id: team_size_id || 1,
        website_url: website_url || "",
      }}
    >
      <TeamSize TeamData={TeamData} />
      <Divider className="!mt-0" />
      <NameAndEmail />
      <Form.Item className="w-full flex justify-center items-center mt-8 !mb-0">
        <button
          type="submit"
          className="rounded-full border-solid border-color-primary border-t-2 border-b-white border-b-2 border-r-2 border-r-white border-l-2 border-l-white rotate-45 cursor-pointer bg-[#EEF0FF] w-14 h-14"
        >
          <IoIosArrowBack className="w-5 h-5 mt-1 -rotate-45 text-color-primary" />
        </button>
      </Form.Item>
    </Form>
  );
};

export default Step1;
